<template>
    <section class="section">
        <nav class="level">
            <!-- Left side -->
            <div class="level-left">
                <h3 class="title is-3">Мои заявки</h3>
            </div>

            <!-- Right side -->
            <div class="level-right">
                <p class="level-item"><router-link class="button is-success" :to="{name: 'my-application.new'}">Создать</router-link></p>
            </div>
        </nav>
        <b-table
            :data="applicationList"

            :per-page="options.perPage"
            :current-page.sync="options.currentPage"
            :pagination-simple="false"
            :backend-pagination="true"
            pagination-position="bottom"
            default-sort-direction="asc"
            sort-icon="chevron-up"
            sort-icon-size="is-small"
            :total="paginator.total"
            :loading="isLoading"

            paginated
            striped
            narrowed
            hoverable
            focusable

            default-sort="title"
            aria-next-label="Следующая страница"
            aria-previous-label="Предыдущая страница"
            aria-page-label="Страница"
            aria-current-label="Текущая страница"
        >
            <b-table-column field="organization.name" label="ЦПО">
                <template v-slot="props">
                    <span :title="organizationsFullPathByUserRoles(props.row.userRolePivot)">{{  organizationNamesByUserRoles(props.row.userRolePivot) }}</span>
                </template>
            </b-table-column>
            <b-table-column label="Роль">
                <template v-slot="props">
                    {{ roleNamesByUserRoles(props.row.userRolePivot) }}
                </template>
            </b-table-column>
            <b-table-column field="status" label="Статус">
                <template v-slot="props">
                    {{ $_get(props.row, 'status') | appStatusToText }}
                </template>
            </b-table-column>
            <b-table-column field="createdAt" label="Дата">
                <template v-slot="props">
                    <b-tag type="is-info is-light">{{ $_get(props.row, 'createdAt') | datetime }}</b-tag>
                </template>
            </b-table-column>
            <b-table-column field="comment" label="Комментарий">
                <template v-slot="props">
                    {{ $_get(props.row, 'comments') }}
                </template>
            </b-table-column>
            <b-table-column label="">
                <template v-slot="props">
                    <div class="buttons">
                        <b-button title="Отозвать" v-if="props.row.status === STATUS_IN_REVIEW" @click="deleteApplication(props)"  icon-right="delete" type="is-danger" size="is-small" />
                    </div>
                </template>
            </b-table-column>
        </b-table>
    </section>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { STATUS_APPROVED, STATUS_DECLINED, STATUS_IN_REVIEW } from '../../../../store/models/applications/model'
import PaginatedFetchMixin from './../../../../mixins/PaginatedFetchMixin.js'
import UserRolesMixin from './../../../../mixins/UserRolesMixin'
import OrganizationFetchMixin from './../../../../mixins/OrganizationFetchMixin'

export default {
    mixins: [
        PaginatedFetchMixin,
        UserRolesMixin,
        OrganizationFetchMixin,
    ],
    mounted () {
        this.fetchOrganizationsIfNeeded()
        this.fetch()
    },
    computed: {
        ...mapGetters({
            currentUser: 'e/users/currentUser',
            currentUserId: 'e/users/currentUserId',
            isLoaderActive: 'e/pages/isLoaderActive',
            applicationsQuery: 'e/applications/query',
        }),
        applicationList() {
            return this.applicationsQuery()
                .with(['user.roles.organization', 'user.roles.role', 'user.roles.position'])
                .findIn(this.paginator.ids)
                //.where('userId', this.currentUserId)
                //.get()
        },
        isLoading() {
            return this.isLoaderActive('applications.fetchItems')
        }
    },
    methods: {
        ...mapActions({
            fetchItems: 'e/applications/fetchMyApplications',
            remove: 'e/applications/remove',
        }),
        deleteApplication(props) {
            this.remove(props.row.id)
        }
    },
    data () {
        return {
            STATUS_IN_REVIEW,
        }
    },
    watch: {
        currentUserId: {
            immediate: true,
            handler(val) {
                this.filters.userId = val
            }
        }
    }
}
</script>